// Hand-off from the Library reader to the generator (one-shot, sessionStorage).
const KEY = 'ae_reader_prefill';

export const READER_DOC_OPTIONS = [
  { id: 'worksheet', label: 'Worksheet', generator: 'quick', taskType: 'Assignment' },
  { id: 'test', label: 'Test / question paper', generator: 'quick', taskType: 'Test' },
  { id: 'summary', label: 'Chapter summary', generator: 'plan', docType: 'summary' },
  { id: 'lesson_plan', label: 'Lesson plan', generator: 'plan', docType: 'lesson_plan' },
  { id: 'ppt', label: 'Slides (PPT)', generator: 'plan', docType: 'ppt' },
];

export function saveReaderPrefill(data) {
  try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch { /* storage unavailable */ }
}

export function peekReaderPrefill() {
  try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch { return null; }
}

// Returns the prefill only for the generator it targets, then clears it.
export function takeReaderPrefill(generator) {
  const p = peekReaderPrefill();
  if (!p || p.generator !== generator) return null;
  try { sessionStorage.removeItem(KEY); } catch { /* noop */ }
  return p;
}
